import actionTypes from "actionTypes";
import * as authApis from "apis/auth";
import { TENANT_UTILS } from "utils/tenants";

export function loginUser({ email, password }, successCallback, errorCallback) {
  return (dispatch) => {
    dispatch({ type: actionTypes.GENERATE_NEW_SESSION_ID });
    return authApis
      .loginUser({ email, password })
      .then(({ data, headers }) => {
        if (data.id) {
          dispatch({
            type: actionTypes.LOGIN_USER,
            payload: {
              id: data?.id,
              email: data?.email,
              name: `${data?.firstName} ${data?.lastName}`,
              roles: data?.roles,
              authToken: headers["auth-token"],
            },
          });
          successCallback();
        }
      })
      .catch(errorCallback);
  };
}

export function loginWithSsoCode(
  code,
  codeVerifier,
  successCallback,
  errorCallback
) {
  return (dispatch) => {
    dispatch({ type: actionTypes.GENERATE_NEW_SESSION_ID });
    return authApis
      .exchangeSsoCode(code, codeVerifier)
      .then(({ data, headers }) => {
        const authToken = headers && headers["auth-token"];
        if (!data || !data.id || !authToken) {
          errorCallback();
          return;
        }
        // Same payload as loginUser, so everything after login is unchanged.
        dispatch({
          type: actionTypes.LOGIN_USER,
          payload: {
            id: data.id,
            email: data.email,
            name: `${data.firstName} ${data.lastName}`,
            roles: data.roles,
            authToken,
          },
        });
        successCallback();
      })
      .catch(errorCallback);
  };
}

export function getUserAccessibleFeatures() {
  return (dispatch) => {
    return authApis
      .userAccessibleFeatures()
      .then((res) => {
        return dispatch({
          type: actionTypes.SET_USER_FEATURE,
          payload: res.data.map((feature) => feature.name),
        });
      })
      .catch(() => {});
  };
}

export function getAllPossibleRoles() {
  return (dispatch) => {
    return authApis
      .getAllPossibleRoles()
      .then((res) => {
        dispatch({
          type: actionTypes.SET_ALL_ROLES,
          payload: res.data.map((feature) => feature.role),
        });
      })
      .catch(() => {});
  };
}

export function logoutUser() {
  return (dispatch) => {
    const localLogout = function () {
      TENANT_UTILS.clearTenantInfoFromCache();
      dispatch({
        type: actionTypes.LOGOUT_USER,
      });
    };
    authApis.logoutUser().then(localLogout).catch(localLogout);
  };
}

export const authenticateUser = () => (dispatch, getState) => {
  const authToken = getState?.().userInfo?.authToken;
  if (!authToken) {
    dispatch(logoutUser());
    return Promise.reject(new Error("No auth token present"));
  }

  return authApis
    .authenticate()
    .then(({ data }) => {
      const payload = {
        id: data.user.id,
        name: data.user.name,
        email: data.user.email,
        roles: data.user.roles.map((item) => item.role),
        doSelectGrowthProperties: data.user.doSelectGrowthProperties,
      };
      dispatch({
        type: actionTypes.UPDATE_USER,
        payload,
      });
      return dispatch(getUserAccessibleFeatures());
    })
    .catch(() => {
      dispatch(logoutUser());
      return Promise.reject();
    });
};
